module.exports = __webpack_public_path__ + "img/logo_previda.d8bf7882.png";